import styled from "styled-components";

export const MainContainer = styled.div`
    margin-top: -60px;
    padding-bottom: 5rem;
`;